import { createObserver } from "../../components/observer-factory";

const swiperObserver = createObserver(0.15);

function product_detail_similar_products_is_intersecting() {
  //console.log('element', this);
  import("swiper").then((swiper) => {
    /* const similar_products_swiper = */ new swiper.Swiper('#product-detail-similar-products .swiper-container', {
      modules: [swiper.Navigation, swiper.Pagination],
      pagination: {
        el: '#product-detail-similar-products .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '#product-detail-similar-products .swiper-navigation-next',
        prevEl: '#product-detail-similar-products .swiper-navigation-prev',
      },
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        }
      }
    })
    // console.log('swiper is imported');
  },(/* error */) => {
    // console.error('Swiper dahil edilemedi. (product-detail.js)', error);
  });
  this.removeEventListener('intersecting', product_detail_similar_products_is_intersecting);
}

document.addEventListener('DOMContentLoaded', () => {
  const product_detail_similar_products = document.getElementById('product-detail-similar-products');
  swiperObserver.observe(product_detail_similar_products);
  product_detail_similar_products.addEventListener('intersecting', product_detail_similar_products_is_intersecting);
});